import { get } from "lodash";

import type { Race } from "@tvg/ts-types/Race";
import mediator from "@tvg/mediator";
import { events as AlchemerEvents } from "@urp/alchemer";
import { doesSilkLoads } from "@tvg/sh-utils/raceUtils";

export const buildQaLabel = (labels: string[]) =>
  labels.filter(Boolean).join("-");

export const getShouldShowSilks = async (
  races: Array<Race>
): Promise<Array<Array<boolean>>> => {
  const shouldShowSilks = await Promise.all(
    races.map(async (race) => {
      const bettingInterests = get(race, "bettingInterests", []);
      if (bettingInterests.length) {
        return doesSilkLoads(bettingInterests);
      }
      return [false];
    })
  );

  return shouldShowSilks;
};

export const sendAnalyticsEvt = (race: Race, url: string, section: string) => {
  AlchemerEvents.selectPopularRace();
  mediator.base.dispatch({
    type: "HEADER_GO_TO_RACE",
    payload: {
      section,
      url,
      race
    }
  });
};

export const getCardIndex = (scrollContainer: HTMLDivElement | null) => {
  if (!scrollContainer || scrollContainer.children?.length === 0) return 0;

  const cardElements = Array.from(scrollContainer.children) as HTMLElement[];
  const cardWidth = cardElements.length > 0 ? cardElements[0].offsetWidth : 0;
  const { clientWidth: viewportWidth, scrollLeft } = scrollContainer;

  const newVisibleCardIndex = Math.min(
    Math.floor((scrollLeft + viewportWidth) / cardWidth),
    cardElements.length - 1
  );

  return newVisibleCardIndex;
};
